import {Stack} from 'aws-cdk-lib'
import {CfnRoute, CfnVPCPeeringConnection, IVpc, SubnetSelection} from 'aws-cdk-lib/aws-ec2'

export type VpcPeering = Readonly<{
    vpc: IVpc
    subnetSelection: SubnetSelection
}>

export type VpcPeeringInput = Readonly<{
    fromVpcPeering: VpcPeering
    toVpcPeering: VpcPeering
}>

/** Creates a VPC peering connection with bidirectional routes across selected subnets. */
export const withVpcPeering = (deps: {
    stack: Stack
    withId: (identifier: string) => string
}) =>
    (input: VpcPeeringInput): CfnVPCPeeringConnection => {
        const peeringConnection = new CfnVPCPeeringConnection(deps.stack, deps.withId('PeeringConnection'), {
            vpcId: input.fromVpcPeering.vpc.vpcId,
            peerVpcId: input.toVpcPeering.vpc.vpcId
        })

        input.fromVpcPeering.vpc.selectSubnets(input.fromVpcPeering.subnetSelection).subnets
            .forEach(({routeTable: {routeTableId}}, index) => {
                new CfnRoute(deps.stack, deps.withId(`PeeringRouteFromSubnet-${index}`), {
                    destinationCidrBlock: input.toVpcPeering.vpc.vpcCidrBlock,
                    routeTableId: routeTableId,
                    vpcPeeringConnectionId: peeringConnection.ref,
                })
            })

        input.toVpcPeering.vpc.selectSubnets(input.toVpcPeering.subnetSelection).subnets
            .forEach(({routeTable: {routeTableId}}, index) => {
                new CfnRoute(deps.stack, deps.withId(`PeeringRouteToSubnet-${index}`), {
                    destinationCidrBlock: input.fromVpcPeering.vpc.vpcCidrBlock,
                    routeTableId: routeTableId,
                    vpcPeeringConnectionId: peeringConnection.ref,
                })
            })

        return peeringConnection
    }
